import { Link } from "react-router-dom";
import Reveal from "@/components/store/Reveal";
import { mediaUrl } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";

const U = "https://images.unsplash.com/photo-";
const img = (id) => `${U}${id}?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000`;

const SHOTS = [
  { slot: "lookbook_1", src: img("1587366801951-0dcd4ae429f9"), span: "row-span-2", cap: "Amalfi in bloom" },
  { slot: "lookbook_2", src: img("1776633734208-3cdf89a7fbf0"), cap: "Mykonos linen" },
  { slot: "lookbook_3", src: img("1699952298589-1d568db5d607"), cap: "Seafoam days" },
  { slot: "lookbook_4", src: img("1759825413442-060ed08812ab"), span: "row-span-2", cap: "Tulum set" },
  { slot: "lookbook_5", src: img("1630557802095-838465e86620"), cap: "Santorini wrap" },
  { slot: "lookbook_6", src: img("1659522761084-79196b64abe4"), cap: "One of one" },
  { slot: "lookbook_7", src: img("1606924228285-f924ab34ccd9"), span: "row-span-2", cap: "Golden hour" },
  { slot: "lookbook_8", src: img("1566727123275-35af43654aeb"), cap: "Riviera swim" },
  { slot: "lookbook_9", src: img("1767440527251-537eb325b986"), cap: "Off-duty white" },
];

export default function Lookbook() {
  const { settings } = useSettings();
  const pi = settings?.page_images || {};
  return (
    <div className="px-6 md:px-12 py-14" data-testid="lookbook-page">
      <div className="text-center mb-14">
        <p className="eyebrow mb-3">The Lookbook</p>
        <h1 className="font-heading text-4xl md:text-6xl tracking-tight">Worn by the Voyage</h1>
        <p className="font-body text-sm text-ink/60 max-w-lg mx-auto mt-5 leading-relaxed">An editorial study in rescued fabric, sun-warmed light and pieces made to move with you.</p>
      </div>

      <div className="mx-auto max-w-[1200px] grid grid-cols-2 md:grid-cols-3 auto-rows-[220px] md:auto-rows-[280px] gap-4">
        {SHOTS.map((s, i) => (
          <Reveal key={i} delay={(i % 3) * 80} className={s.span || ""}>
            <figure className="group relative overflow-hidden bg-cream h-full">
              <img src={mediaUrl(pi[s.slot] || s.src)} alt={pi[`${s.slot}_alt`] || s.cap} className="w-full h-full object-cover vintage-photo transition-transform duration-700 group-hover:scale-105" />
              <figcaption className="absolute inset-0 flex items-end p-4 bg-gradient-to-t from-ink/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <span className="font-heading italic text-xl text-linen">{s.cap}</span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <div className="text-center mt-14"><Link to="/shop" className="btn-primary" data-testid="lookbook-shop-cta">Shop the Collection</Link></div>
    </div>
  );
}
